<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCSVGraphs(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :zoomGraphValue="zoomGraphValue" :specificSiteId="specificSiteId" :downloadShow="dataSource.categories && Object.keys(dataSource.categories[0].category).length > 0">
    <fusioncharts slot="body" v-if="dataSource.categories && Object.keys(dataSource.categories[0].category).length > 0" style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="formStatus"> </fusioncharts>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import { downloadCSV, getContrast, primaryColorFnc, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "@/components/containers/chart-container";
import * as dManagement from "@/services/visualization/new-data-management";

export default {
  components: { ChartContainer },
  props: {
    formStatusRaw: { type: Object },
    xAxisName: { type: String, default: "" },
    yAxisName: { type: String, default: "" },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    specificSiteId: { type: Array, default: () => [] },
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false }
  },
  data() {
    return {
      formStatusSeries: {
        entryCompleted: [],
        approved: [],
        verified: [],
        signOff: [],
        categories: []
      },
      type: "stackedcolumn2d",
      dataFormat: "json",
      width: "100%",
      height: "240",
      dataSource: {
        chart: {
          xAxisname: this.xAxisName,
          yAxisName: this.yAxisName,
          chartTopMargin: 0,
          xAxisNameFontColor: "#959fa4",
          xAxisNameFont: "RobotoMedium",
          xAxisNameFontSize: "9px",
          labelFontSize: "10px",
          labelFont: "RobotoRegular",
          labelFontColor: "#a3a3a3",
          yAxisNameFontColor: "#a3a3a3",
          yAxisNameFont: "RobotoMedium",
          yAxisNameFontSize: "9px",
          yAxisValueFont: "RobotoMedium",
          yAxisValueFontSize: "10px",
          yAxisValueFontColor: "#a3a3a3",
          theme: "fusion",
          legendItemFont: "RobotoRegular",
          legendItemFontColor: "#666669",
          legendCaptionAlignment: "center",
          legendPosition: "top-right",
          legendItemFontSize: "10px",
          baseFontSize: "10",
          divLineAlpha: "0",
          divLineDashed: "0",
          maxColWidth: "73.2",
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          tooltipBorderAlpha: "0",
          toolTipBgAlpha: "0",
          decimals: 0,
          paletteColors: primaryColorFnc() + ",#a6cee3,#7891d1,#56b3b9,#cab2d6,#7f69d4,#fb9a99,#fdbf6f,#b5cdd8",
          chartBottomMargin: "0",
          xAxisNamePadding: "5"
        },
        categories: [{ category: [] }],
        dataset: [
          {
            seriesname: "Entry Completed",
            color: primaryColorFnc(),
            plotToolText: `
                <span class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
                    $dataValue Form(s) Entry Completed
                </span>
            `,
            toolTipBgColor: primaryColorFnc(),
            tooltipborderradius: "5"
          },
          {
            seriesname: "Approved",
            color: "#cab2d6",
            plotToolText: `
                <span class="overall-collection-metric-tooltip missing" style='color:${getContrast("#cab2d6")}'>
                    $dataValue Form(s) Approved
                </span>
            `
          },
          {
            seriesname: "Verified",
            color: "#a6cee3",
            plotToolText: `
                <span class="overall-collection-metric-tooltip verified" style='color:${getContrast("#a6cee3")}'>
                    $dataValue Form(s) Verified
                </span>
            `
          },
          {
            seriesname: "Signed Off",
            color: "#fb9a99",
            plotToolText: `
                <span class="overall-collection-metric-tooltip signed-off" style='color:${getContrast("#fb9a99")}'>
                    $dataValue Form(s) Signed Off
                </span>
            `
          }
        ]
      },
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      getSiteID
    };
  },
  watch: {
    filterTriggered: function() {
      this.formStatusSeries = dManagement.GET_FORM_STATUS_DATA(this.formStatusRaw, this.countrySelected, this.sitesSelected);
    },
    formStatusRaw: function(newValue) {
      this.formStatusSeries = dManagement.GET_FORM_STATUS_DATA(newValue, this.countrySelected, this.sitesSelected);
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "240";
      }
    },
    formStatusSeries: function(newValue) {
      if (newValue) {
        if (newValue.entryCompleted.length > 0) {
          this.dataSource.dataset[0].data = newValue.entryCompleted;
          this.dataSource.dataset[0].color = primaryColorFnc();
          this.dataSource.dataset[0].toolTipBgColor = primaryColorFnc();
          this.dataSource.dataset[0].plotToolText = `
            <span class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
                $dataValue Form(s) Entry Completed
            </span>
          `;
        }
      }
      this.dataSource.dataset[1].data = newValue.approved.length > 0 ? newValue.approved : [];
      this.dataSource.dataset[2].data = newValue.verified.length > 0 ? newValue.verified : [];
      this.dataSource.dataset[3].data = newValue.signOff.length > 0 ? newValue.signOff : [];
      this.dataSource.categories[0].category = newValue.categories.length > 0 ? newValue.categories : [];
    },
    xAxisName: function(newValue) {
      this.dataSource.chart.xAxisname = newValue;
    }
  },
  methods: {
    downloadCSVGraphs(titleChart) {
      const header = ["Days", "Entry Completed Form(s)", "Approved Form(s)", "Verified Form(s)", "Signed Off Form(s)"];

      const newArr = [];
      this.formStatusSeries.entryCompleted.map(row => {
        newArr.push([row.label, row.value]);
      });

      this.formStatusSeries.approved.map((row, i) => {
        newArr[i].splice(2, 0, row.value);
      });

      this.formStatusSeries.verified.map((row, i) => {
        newArr[i].splice(3, 0, row.value);
      });

      this.formStatusSeries.signOff.map((row, i) => {
        newArr[i].splice(4, 0, row.value);
      });

      downloadCSV(titleChart, header, newArr, this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "240";
        this.$emit("zoomDisabled");
      }
    }
  }
};
</script>
